import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import './Downloads.css';

const Downloads = () => {
  const [downloads, setDownloads] = useState([]);
  const [category, setCategory] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ category: '整合包', name: '', description: '', downloadUrl: '', password: '' });
  const { user, loading } = useContext(AuthContext);

  const fetchDownloads = async (cat = '') => {
    try {
      const params = cat ? { category: cat } : {};
      const res = await axios.get('/downloads', { params });
      setDownloads(res.data);
    } catch (err) {
      console.error('获取下载内容失败:', err);
    }
  };

  useEffect(() => {
    if (user) {
      fetchDownloads(category);
    }
  }, [user, category]);

  if (loading) return <div className="loading">加载中...</div>;
  if (!user) return <Navigate to="/account" />;
  if (!user.whitelisted) return <div className="no-access">请先申请白名单</div>;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/downloads', formData);
      setFormData({ category: '整合包', name: '', description: '', downloadUrl: '', password: '' });
      setShowForm(false);
      fetchDownloads(category);
    } catch (err) {
      console.error('上传失败:', err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('确定要删除这个下载内容吗？')) {
      try {
        await axios.delete(`/downloads/${id}`);
        fetchDownloads(category);
      } catch (err) {
        console.error('删除失败:', err);
      }
    }
  };

  return (
    <div className="downloads">
      <h1>下载</h1>
      
      <div className="category-tabs">
        <button
          className={category === '' ? 'active' : ''}
          onClick={() => setCategory('')}
        >
          全部
        </button>
        <button
          className={category === '整合包' ? 'active' : ''}
          onClick={() => setCategory('整合包')}
        >
          整合包
        </button>
        <button
          className={category === '更新内容' ? 'active' : ''}
          onClick={() => setCategory('更新内容')}
        >
          更新内容
        </button>
      </div>

      {user && (user.permission === '腐竹' || user.permission === '管理') && (
        <div className="admin-controls">
          <button onClick={() => setShowForm(!showForm)} className="btn-primary">
            {showForm ? '取消' : '添加下载'}
          </button>
        </div>
      )}

      {showForm && (
        <form onSubmit={handleSubmit} className="download-form">
          <select
            value={formData.category}
            onChange={(e) => setFormData({ ...formData, category: e.target.value })}
          >
            <option value="整合包">整合包</option>
            <option value="更新内容">更新内容</option>
          </select>
          <input
            type="text"
            placeholder="内容名称"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
          />
          <textarea
            placeholder="内容说明"
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            rows={3}
            required
          />
          <input
            type="text"
            placeholder="下载链接"
            value={formData.downloadUrl}
            onChange={(e) => setFormData({ ...formData, downloadUrl: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="下载密码（可选）"
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
          />
          <button type="submit" className="btn-primary">添加</button>
        </form>
      )}

      <div className="downloads-list">
        {downloads.map((item) => (
          <div key={item._id} className="download-card">
            <div className="download-header">
              <h3>{item.name}</h3>
              <span className="download-category">{item.category}</span>
            </div>
            <p className="download-description">{item.description}</p>
            {item.password && <p className="download-password">密码: {item.password}</p>}
            <div className="download-actions">
              <a href={item.downloadUrl} target="_blank" rel="noopener noreferrer" className="btn-primary">
                下载
              </a>
              {user && (user.permission === '腐竹' || user.permission === '管理') && (
                <button onClick={() => handleDelete(item._id)} className="btn-delete">删除</button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Downloads;
